import "./detailsListStyles.scss";
import CarCheck from "./car-check.png";
import Faucet from "./faucet.png";
import Like from "./like.png";
import Time from "./time.png";
import Financing from "./financing.png";
import PrecioJustoImage from "./precio-justo.png";
import PeritajeIcon from "./peritajeIcon.png";
import { Link } from "react-router-dom";
import { routes } from "../../../../../routes/RoutesComponent";
import { useState } from "react";
import { Arrow } from "../../../../../assets/arrow";
import VideoButton from "../../../../../components/VideoButton/VideoButton";

export const DetailsList = ({ setShowPeritajeImage, warranty, car, description }) => {
    const [warrantyInfo, setWarrantyInfo] = useState(false);
    console.warn("car", car.id, car);
    const warrantyMessage = () => {
        if (!car.warranty_type || car.warranty_type === "null") return "Garantía 6 meses";

        switch (car.warranty_type) {
            case "Garantía de 6 meses o 4000 km":
                return "Garantía 6 meses";
            case "Garantía de marca o km":
                return "Garantía de fábrica";
            case "Garantía por 1 año":
                return "Garantía 1 año";
            default:
                return "Garantía 6 meses";
        }
    };
    return (
        <>
            <div className="details_list">
                <div className="items_list">
                    {/* {car.type_warranty == "si" && (
                        <>
                            <p className="item price">
                                <img src={PrecioJustoImage} alt="wcar" />
                                Garantia de 7 dias
                            </p>
                            <hr />
                        </>
                    )} */}

                    {warranty && (
                        <>
                            <div
                                style={{ display: "flex", position: "relative", cursor: "pointer" }}
                                onClick={() => setWarrantyInfo(!warrantyInfo)}
                            >
                                <p>
                                    <img src={CarCheck} alt="Garantia" />
                                    {warrantyMessage()}
                                </p>
                                {/* <div
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        marginTop: "0",
                                    }}
                                >
                                    <div
                                        className="ms-2 claims_arrow"
                                        style={{
                                            transform: warrantyInfo ? "rotate(0deg)" : "rotate(180deg)",
                                        }}
                                    >
                                        <Arrow />
                                    </div>
                                </div> */}
                                {/* <span
                                    className="warranty_tool_tip_detail position-absolute"
                                    style={{ display: warrantyInfo ? "block" : "none", marginTop: "10px" }}
                                >
                                    Garantía: Te ofrecemos una garantía máxima de (1) año, o 4.000 kilómetros, lo que
                                    primero ocurra. No cubrimos piezas de desgaste ni daños ocasionados por mal manejo o
                                    falta de mantenimiento. Para conocer el detalle, ponte en contacto con un consejero.
                                </span> */}
                            </div>
                            <hr />
                        </>
                    )}
                    <a href="#financingBanner" className="item financing_text">
                        <img src={Financing} alt="Financiación hasta del 100% del vehiculo" /> Financiación hasta del
                        100% del vehiculo
                    </a>
                    <hr />
                    <p className="item price">
                        <img src={PrecioJustoImage} alt="Precio más justo" />
                        Precio más justo&nbsp;<span> del mercado</span>
                    </p>
                    <hr />
                    {/* <a href="#financingBanner" className="item financing_text">
                        <img src={Financing} alt="wcar" />
                        Credi facil: <span style={{ marginLeft: "6px" }}> Financiación hasta&nbsp;del 100%</span>
                    </a>
                    <hr /> */}
                    <a href="#financingBanner" className="item financing_text">
                        <img src={Time} alt="Financia hasta $15 millones en 3 minutos" />
                        Financia hasta $15 millones en 3 minutos
                    </a>
                    {car.garantia7dias && (
                        <>
                            <hr />
                            <p className="item">
                                <img src={Like} alt="Garantía de felicidad: 7 días o te cambiamos el carro" /> Garantía
                                de felicidad: 7 días o te cambiamos el carro
                            </p>
                        </>
                    )}
                    {car.videoUrl && (
                        // En mobile el boton va debajo de las fotos (ver CarCarouselImagesComponent).
                        <div className="d-none d-lg-block">
                            <hr />
                            <div className="mt-2" />
                            <VideoButton car={car} />
                        </div>
                    )}
                    {/* <hr /> */}
                    {/* <p onClick={() => setShowPeritajeImage(true)} style={{ cursor: "pointer", color: "#000" }}>
                        <img src={PeritajeIcon} alt="wcar" /> <strong>Peritaje de Colserauto Gratis</strong>
                    </p> */}
                </div>
            </div>
        </>
    );
};
